/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { SvenskdamStandaloneCoverBox as ResolvedStandaloneCoverBox } from 'sites/svenskdam/components/standalone/CoverBox';

export const CoverBox: typeof ResolvedStandaloneCoverBox = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneCoverBox {...props} />
        </ErrorBoundary>
    );
});

export type CoverBoxProps = PropsFromComponent<typeof CoverBox>;

/** @deprecated Use slot architecture instead */
export const CoverBoxWith = (extras: DynamicStandaloneExtras): typeof CoverBox => {
    return function CoverBox(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'CoverBox');
        return <ResolvedStandaloneCoverBox {...mergeProps({ options: { theme } }, props)} />;
    }
}